import { useAppConfigContext } from '@/context/AppContext';
import Div from '@/shared/Div';
import Star from '../Icons/Star';
import Paragraph from '@/shared/Paragraph';
import { getFormattedPrice } from '@/utils/price';
import classNames from 'classnames';

const Commission = ({ commission, sellingPrice, className }: any) => {
  const { state: config } = useAppConfigContext();
  if (!config.isSCAClient || commission <= 0 || commission >= sellingPrice) return null;
  const roundedCommission = Math.round(commission);
  return (
    <Div className="flex items-center gap-s2">
      <Star />
      <Paragraph className={classNames('text-button-small text-blue-400', className)}>
        Earn {getFormattedPrice(roundedCommission)} per sale
      </Paragraph>
    </Div>
  );
};
export default Commission;
